export const GET_ALL_CONCEPTS_DISCOUNT     = 'GET_ALL_CONCEPTS_DISCOUNT';
export const SAVE_CONCEPT_DISCOUNT         = 'SAVE_CONCEPT_DISCOUNT';
export const CHANGE_VALUE_CONCEPT_DISCOUNT = 'CHANGE_VALUE_CONCEPT_DISCOUNT';
export const GET_INFO_CONCEPT_DISCOUNT     = 'GET_INFO_CONCEPT_DISCOUNT';
export const DELETE_CONCEPT_DISCOUNT       = 'DELETE_CONCEPT_DISCOUNT';